import { useFlags } from "pages/Proposal/hooks/useFlags"

import { fields } from "./fields"

const useFormGroupReferral = () => {
  const { hasReferral: hasReferralFlag } = useFlags()

  return {
    fields,
    hasReferralFlag
  }
}

export default useFormGroupReferral
